import tw from "twin.macro";

export const SectionHeading = tw.h2`text-5xl  font-black tracking-wide text-center`
export const Subheading = tw.h5`font-bold text-primary-600`
